export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
];

export const DEFAULT_ROLE_PERMISSIONS = {
  manager: [
    'inbox',
    'conversation',
    'all_conversations',
    'mentions',
    'unattended',
    'folders',
    'teams',
    'channels',
    'labels',
    'contacts',
    'all_contacts',
    'active_contacts',
    'segments',
    'contact_labels',
    'companies',
    'all_companies',
    'reports',
    'reports_overview',
    'reports_conversation',
    'reports_agent',
    'reports_label',
    'reports_inbox',
    'reports_team',
    'reports_csat',
    'reports_sla',
    'reports_bot',
    'settings',
    'settings_agents',
  ],
  agent: [
    'inbox',
    'conversation',
    'all_conversations',
    'mentions',
    'unattended',
    'folders',
    'teams',
    'channels',
    'labels',
    'contacts',
    'all_contacts',
    'active_contacts',
    'segments',
    'contact_labels',
    'companies',
    'all_companies',
  ],
};

export const ROLES = ['agent', 'administrator', 'manager'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};
